export default "__VITE_ASSET__BC00ynCq__"